import React, { useEffect } from 'react'
import TableComponent from '../../../Common/TableComponent/tableComponent'
import { useState } from 'react';
import * as XLSX from "xlsx";
import { useForm } from 'react-hook-form';
import { TableLoader } from '../../../Common/ShimmerLoader';
import {  MasterCollectionPointReportResult } from '../../../Apis/gvpClearanceReportApi';
import { AllShiftMaster } from '../../../Apis/shiftMasterApi';
import { GetCirclebyID, GetWardsbyCircleId, GetZone } from '../../../Apis/organizationApi';

function GVPsMaster() {
    const { register, handleSubmit, formState: { errors }, } = useForm();
    const gvpMasterHeader = [
        "collectionPointName",
        "zone",
        "circle",
        "ward",
        "shiftId",
        "shiftName",
        "latitude",
        "longitude",
        "updatedDate",
    ];
    const [isOptionsLoading, setIsOptionsLoading] = useState(false);
    const [getMasterReport, setGetMasterReport] = useState([]);
    const [shiftData, setShiftData] = useState([]);
    const [allZones, setAllZones] = useState([]);
    const [selectedZone, setSelectedZone] = useState("");
    const [selectedCircles, setSelectedCircles] = useState([]);
    const [loadingCircles, setLoadingCircles] = useState(false);
    const [loadingWards, setLoadingWards] = useState(false);
    const [wards, setWards] = useState([]);
    const [circles, setCircles] = useState([]);
    const [selectedWard, setSelectedWard] = useState("");
    const [formInput, setFormInput] = useState({
        ShiftId: "",
        ZoneId: "",
        CircleId: "",
    });

    const zoneColumns = [
        {
            name: 'Sl.No',
            selector: (row) => row['slno'],
            sortable: true,
            format: (row, rowIndex) => rowIndex + 1,
        },
        {
            name: 'zoneName',
            selector: (row) => row['zoneName'],
            sortable: true,
        },
        {
            name: 'zoneId',
            selector: (row) => row['zoneId'],
            sortable: true,
        },
        {
            name: 'wardNotTs',
            selector: (row) => row['wardNotTs'],
            sortable: true,
        },
        {
            name: 'wardTS',
            selector: (row) => row['wardTS'],
            sortable: true,
        },
        {
            name: 'underRepair',
            selector: (row) => row['underRepair'],
            sortable: true,
        },
        {
            name: 'notWardButTs',
            selector: (row) => row['notWardButTs'],
            sortable: true,
        },
        {
            name: 'condemned',
            selector: (row) => row['condemned'],
            sortable: true,
        },
        {
            name: 'ward',
            selector: (row) => row['ward'],
            sortable: true,
        },
        {
            name: 'total',
            selector: (row) => row['total'],
            sortable: true,
        },

        {
            name: 'active',
            selector: (row) => row['active'],
            sortable: true,
        },
    ]

    const fetchShift = async () => {
        try {
            const response = await AllShiftMaster();
            setShiftData(response);
        } catch (error) {
        }
    }

    const searchMasterReport = async (data) => {
        setIsOptionsLoading(true);
        try {
            const { ZoneId, CircleId, ShiftId } = formInput;
            const requestData = {
                ZoneId,
                CircleId,
                ShiftId
            }
            const res = await MasterCollectionPointReportResult(requestData);
            const modifiedResponse = res.map(item => ({
                ...item,
                zone: item.zoneName,
                circle: item.circleName,
                ward: item.wardName,
            }));

            setGetMasterReport(modifiedResponse)
        } catch (error) {
        } finally {
            setIsOptionsLoading(false);
        }
    }

    useEffect(() => {
        fetchShift();
        fetchAllDataDetails();
    }, [])

    const handleKeyDown = (event, callback) => {
        if (event.key === "Enter" && event.shiftKey === false) {
            event.preventDefault();
            callback(searchMasterReport);
        }
    };


    const handleZoneChange = async (ZoneId) => {
        setFormInput((prevData) => ({
            ...prevData,
            ZoneId: ZoneId,
            circleId: "",
        }));
        setSelectedCircles("");
        setSelectedWard("");
        if (ZoneId) {
            try {
                const circlesData = await GetCirclebyID(ZoneId);
                setCircles(circlesData);
            } catch (error) {
            }
        } else {
            setCircles([]);
        }
    };

    const handleCircleChange = async (CircleId) => {
        setFormInput((prevData) => ({
            ...prevData,
            circleId: CircleId,
        }));
        setSelectedWard("");
        if (CircleId) {
            try {
                const wardsData = await GetWardsbyCircleId(CircleId);
                // Assuming there's a function to fetch wards by circle ID
                setWards(wardsData);
            } catch (error) {
            }
        } else {
            // If no circle is selected, clear wards dropdown
            setWards([]);
        }
    };

    const fetchAllDataDetails = async () => {
        try {
            const zonesData = await GetZone();
            setAllZones(zonesData);
            if (selectedZone) {
                const circlesData = await GetCirclebyID(selectedZone);
                // console.log(circlesData, "circleDAAATAA")
                setCircles(circlesData);
                setSelectedCircles([]);
                setIsOptionsLoading(false)
            } else {
                setCircles([]);
                setSelectedCircles([]);
            }
        } catch (error) {
        }
    };

    const downloadMasterAsExcel = () => {
        const ws = XLSX.utils.json_to_sheet(getMasterReport);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "gvpMasterReports");
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8" });
        const downloadLink = document.createElement("a");
        downloadLink.href = URL.createObjectURL(data);
        downloadLink.download = "gvpMasterReports.xlsx";
        downloadLink.click();
    };

    return (
        <>
            <div style={{ width: "100%" }}>
                <div className="content">
                    <div className="page-content">
                        <div className="page-header">
                            <div className="card">
                                <div className="card-body">
                                    <span style={{ display: "flex-Start" }}><h5>GVPs Master</h5></span>
                                    <div className="text-end mt-3">
                                        <button
                                            className="btn btn-danger"
                                            style={{ backgroundColor: "#EC1117" }}
                                            onClick={downloadMasterAsExcel}
                                        >
                                            Download Excel
                                        </button>
                                    </div>
                                    <form onSubmit={handleSubmit(searchMasterReport)}
                                        onKeyDown={(e) => {
                                            handleKeyDown(e, handleSubmit);
                                        }}>
                                        <div class="row mt-5" style={{ textAlign: "justify" }}>
                                            <div class="col-md-3 mb-2">
                                                <label htmlFor="StartDate">Zone:</label>
                                                <select
                                                    {...register("ZoneId")}
                                                    name="ZoneId"
                                                    value={formInput.ZoneId}
                                                    className="form-select"
                                                    onChange={(e) => handleZoneChange(e.target.value)}
                                                >
                                                    <option value="">Select</option>
                                                    {allZones?.map((zone) => (
                                                        <option key={zone.zoneId} value={zone.zoneId}>
                                                            {zone.zoneName}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                            <div class="col-md-3 mb-2">
                                                <label htmlFor="StartDate">Circle:</label>
                                                <select
                                                    name="CircleId"
                                                    className="form-select"
                                                    {...register("CircleId")}
                                                    value={formInput.CircleId}
                                                    onChange={(e) => {
                                                        setFormInput((prevData) => ({
                                                            ...prevData,
                                                            CircleId: e.target.value,
                                                        }));
                                                        handleCircleChange(e.target.value);
                                                    }}
                                                // disabled={!formInput.ZoneId}
                                                >
                                                    <option value="">
                                                        --select--
                                                    </option>
                                                    {loadingCircles && (
                                                        <option disabled>Loading circles...</option>
                                                    )}
                                                    {Array.isArray(circles) && circles.length > 0 ? (
                                                        circles.map((circle) => (
                                                            <option key={circle.circleId} value={circle.circleId}>
                                                                {circle.circleName}
                                                            </option>
                                                        ))
                                                    ) : (
                                                        <option value="" disabled>
                                                            No circles found
                                                        </option>
                                                    )}
                                                </select>
                                            </div>
                                            <div className="col-md-3  mb-2">
                                                <div className="form-group">
                                                    <label className="form-label">Shift</label>
                                                    <select
                                                        className="form-select"
                                                        style={{ backgroundColor: "#fff" }}
                                                        name="ShiftId"
                                                        id="ShiftId"
                                                        {...register("ShiftId")}
                                                        value={formInput.ShiftId}
                                                        onChange={(e) => setFormInput({ ...formInput, ShiftId: e.target.value })}
                                                    >
                                                        <option value="">--select--</option>
                                                        {shiftData.map((shift) => (
                                                            <option value={shift.shiftId} key={shift.shiftId}>{shift.shiftName}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="col-md-3 mt-4">
                                                <button type="submit" className='btn btn-danger' style={{ backgroundColor: '#EC1117' }}>Search</button>
                                            </div>
                                        </div>
                                    </form>
                                    <div className="card mt-2">
                                        <div className="card-body">
                                            <div className="top-header">
                                                <span>
                                                    {" "}
                                                    GVPs Master
                                                </span>
                                            </div>
                                            {/* <CustomDataTable
                                                        columns={zoneColumns}
                                                        data={getMasterReport}
                                                        isLoading={isLoading}
                                                    /> */}
                                            <TableComponent
                                                DataFetchURL={getMasterReport}
                                                headers={gvpMasterHeader}
                                                filterFunction={(data) =>
                                                    data.filter(
                                                        (item) => item.status === 1 || item.status === 0
                                                    )
                                                }
                                            // editData={handleEditRoute}
                                            // editRouteData={editRouteData}
                                            // viewData={(id) => handleViewRoute(id)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default GVPsMaster